import { render, staticRenderFns } from "./SocioDemoSettings.vue?vue&type=template&id=00903c7e&lang=pug"
import script from "./SocioDemoSettings.vue?vue&type=script&lang=js"
export * from "./SocioDemoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports